// eslint-disable-next-line
import React, { useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Slide,
  Stack,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { connect } from "react-redux";
import {
  setMsgTone,
  setMsgTone2,
  setcontactlist,
  setValue,
  setShowingStatus,
  setShowingStatusVoice,
  setShowingStatusClass,
  setReadyButton,
  updateNotification,
  setsidebarVal,
  setAgentList,
  endInteraction,
  setArrivalMessage,
  GetAllUsers,
  setExternalChatData,
  updateContactList,
  getIncomingChatData,
  AddNewChat,
  setCustomerTyping,
  showLastMsgExternal,
  showLastMsgInternal,
  updateSetExternalChatData,
  setCustomerTypingId,
  UpdateExternalContactList,
  // sdk--------------------
  setDialedNumberInc,
  setshowIncommingscreen,
  setagentDialedNumber,
  setshowphonedialer,
  setconsultedContactId,
  setVoiceSessionId,
  setseletedVoiceSessionId,
  setCli,
  setendchatModalDialog,
  CustomerNameApi,
  addCallToList,
  removeCallFromList,
  callTransfered,
  swapTransferCallToMainCall,
  removeSecondCallFromConferance,
  callConferanced,
  holdCall,
  ConsultedHoldCall,
  unHoldCall,
  changeIsConfer,
  convertBarginCallToMainCall,
  add2CallToList,
  setIsBarginCall,
  // sdk--------------------
} from "../../Redux/Actions/actions";
import audiosound from "../../Assets/IncomingMsgTone/mixkit-happy-bells-notification-937_k1WB7zZF.wav";
import audiosound2 from "../../Assets/IncomingMsgTone/mixkit-software-interface-start-2574_18SqH3Nv.wav";
import soundfile from "../../Components/DialerComponent/callmoduleassets/ringsound/telephone_ring.mp3";
import msgToneSound from "../../Assets/IncomingMsgTone/wattsapp-29575.mp3";
import { ToastContainer, Flip, toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";
import {
  AesToken,
  BaseUrl,
  SocketUrl,
  wsUri,
} from "../../Container/BaseUrl/BaseUrl";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import moment2 from "moment-timezone";
import {
  DummyReport,
  end_call,
} from "../../Components/Utils/Call-utils/call-utils";
import { useStopwatch } from "react-timer-hook";
import { io } from "socket.io-client";
import Sidebar from "../../Components/sidebar-components/Sidebar";
import Dialer from "../../Components/DialerComponent/Dialer";
import NewIncominCall from "../../Components/DialerComponent/NewIncominCall";
import ComposeNewEmailComponent from "../../Components/ComposeMail-Component/Compose-New-Email";
import Navbar from "../../Components/navbar-components/Navbar";
import NewIncomingRequest from "../../Components/New-incoming-request-component/New-incoming-request.component";
import { CreateAbandoned } from "../../Utils/CreateAbandoned";
import EndChatModelForPopCall from "../../Components/chat-components/Chat-component/chat-component-model/End-chat-model-for-popCall";
import EndChatModel from "../../Components/chat-components/Chat-component/chat-component-model/End-chat-model";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mapStateToProps = (state) => {
  return {
    msgTone: state.data.msgTone,
    msgTone2: state.data.msgTone2,
    chat: state.data.chat,
    userChatID: state.contactListData.userChatID,
    contactList: state.contactListData.contactList,
    contactList2: state.data.contactList2,
    readyButton: state.contactListData.readyButton,
    showingStatus: state.contactListData.showingStatus,
    showingStatusVoice: state.contactListData.showingStatusVoice,
    showingStatusClass: state.contactListData.showingStatusClass,
    agentList: state.data.agentList,
    externalChatData: state.contactListData.externalChatData,
    chatSessionId: state.contactListData.chatSessionId,
    sidebarVal: state.contactListData.sidebarVal,
    // sdk
    callList: state.voice.callList,
    voiceAvailable: state.contactListData.voiceAvailable,
    showIncommingscreen: state.voice.showIncommingscreen,
    dailedNumberInc: state.voice.dailedNumberInc,
    agentDialedNumber: state.voice.agentDialedNumber,
    showphonedialer2: state.voice.showphonedialer2,
    showphonedialer: state.voice.showphonedialer,
    contactId: state.voice.contactId,
    consultedContactId: state.voice.consultedContactId,
    voicePlatForm: state.voice.voicePlatForm,
    webRTC: state.voice.webRTC,
    endchatModalDialog: state.voice.endchatModalDialog,
    // sdk
  };
};

const Main = (props) => {
  const stopwatch2 = useStopwatch({ autoStart: false });
  const stopwatch1 = useStopwatch({ autoStart: false });
  const AvcUrl = localStorage.getItem("AvcUrl");
  let callObj1 = useRef(null);
  let callObj2 = useRef(null);
  let callmap = useRef({});
  let socket = useRef(null);
  let stompClient = useRef(null);
  let ExtNo = useRef(null);
  let ExtPass = useRef(null);
  const [dailedNumber, setDialedNumber] = useState("");
  const [showComposeMail, setshowComposeMail] = useState(false);
  const [OnlineStatus, setOnlineStatus] = useState(false);
  const [aesSocket, setAesSocket] = useState("");
  const [isAesLoginReload, setIsAesLoginReload] = useState(false);
  const [isAesReadyReload, setisAesReadyReload] = useState(false);
  const [autoCallDropOpen, setAutoCallDropOpen] = useState(false);
  const [seconds, setSeconds] = useState(0);
  let datas = JSON.parse(localStorage.getItem("tokenAgent")) || {};
  let selectedChat = JSON.parse(localStorage.getItem("client")) || {};
  const navigate = useNavigate();
  const myref = useRef(null);
  const audioRef = useRef(null);
  const audioRef2 = useRef(null);
  const incomingCall = useRef(null);
  const msgtone = useRef(null);
  const aesWebSocket = useRef(null);
  const playRingSound = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  const playRingSound2 = () => {
    if (audioRef2.current) {
      audioRef2.current.play();
    }
  };
  const playMsgTone = () => {
    if (msgtone.current) {
      msgtone.current.play();
    }
  };
  const playIncomingCall = () => {
    if (incomingCall.current) {
      incomingCall.current.play();
    }
  };
  const pauseIncomingCall = () => {
    if (incomingCall.current) {
      incomingCall.current.pause();
    }
  };
  const funonline = () => {
    setOnlineStatus(false);
    props.getIncomingChatData();
  };
  const funOffline = () => {
    setOnlineStatus(true);
  };

  const handleClickOpen = () => {
    setAutoCallDropOpen(true);
  };
  const handleClose = () => {
    setAutoCallDropOpen(false);
  };
  // Timer Effect
  useEffect(() => {
    let timer;
    if (autoCallDropOpen && seconds > 0) {
      timer = setTimeout(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    }
    if (autoCallDropOpen && seconds === 0) {
      updateStatus("Ready");
      setAutoCallDropOpen(false);
      setSeconds(15);
    }
    return () => clearTimeout(timer);
  }, [autoCallDropOpen, seconds]);

  useEffect(() => {
    window.addEventListener("online", funonline);
    window.addEventListener("offline", funOffline);
    props.getIncomingChatData();

    return () => {
      window.removeEventListener("online", funonline);
      window.removeEventListener("offline", funOffline);
    };
  }, []);

  // Poll for incoming chats only while the agent is Ready and has no contacts assigned
  useEffect(() => {
    if (props.contactList2?.length !== 0 || props.showingStatus !== "Ready") {
      return;
    }

    const hasActiveInteraction = (
      JSON.parse(localStorage.getItem("permission")) || []
    ).some(
      (module) =>
        module.moduleName === "CHAT_INTERACTION" &&
        module.screen.some(
          (item) =>
            item.screenId === "AUTO_INCOMING_REQUEST" && item.read && item.write,
        ),
    );
    if (!hasActiveInteraction) {
      return;
    }

    const incomingChatInterval = setInterval(
      () => {
        props.getIncomingChatData();
      },
      5 * 60 * 1000,
    );

    return () => clearInterval(incomingChatInterval);
  }, [props.contactList2?.length, props.showingStatus]);

  // The connection is held for the whole mount. It used to be rebuilt on every
  // chatSessionId change, which left the agent unregistered for a few hundred
  // ms after each chat select/end - long enough for socket.io to drop a
  // get-new-req emitted in that window, since it does not buffer for a
  // disconnected client.
  useEffect(() => {
    socket.current = io(SocketUrl + `/${localStorage.getItem("TenantId")}`);
    socket.current.on("connect", () => {
      const datas = JSON.parse(localStorage.getItem("tokenAgent"));
      let selectedChat = JSON.parse(localStorage.getItem("client"));
      // console.log("selectedChat", selectedChat);

      if ((selectedChat ? selectedChat.chat_type : "") == "internal") {
        let sender_id = selectedChat
          ? selectedChat.senderDetails[0]._id
          : selectedChat.reciverDetails[0]._id;
        let loggedInAgent = datas.id;
        if (sender_id == loggedInAgent) {
          socket.current.emit("add-user", datas.id);
          console.log("Socket Connected internal 1 block", datas.id);
        } else {
          socket.current.emit("add-user", selectedChat.id);
          console.log("Socket Connected internal 2 block", selectedChat.id);
        }
      } else {
        console.log("Socket Connected External");
        socket.current.emit("add-user", datas.id);
      }
    });
    return () => {
      socket.current.off("connect");
      socket.current.disconnect();
    };
  }, []);

  // Handlers are re-attached on every chatSessionId change so they keep fresh
  // closures, exactly as before - only the connection itself is left alone.
  useEffect(() => {
    socket.current.on("get-new-req", (newUser) => {
       console.log("get-new-req inside", newUser);
      try {
        const datas = JSON.parse(localStorage.getItem("tokenAgent"));
        if (datas.id === newUser.agent) {
          const incomingChat =
            JSON.parse(localStorage.getItem("incomingChat")) || [];

          const isChatSessionIdPresent = incomingChat.some((chat) => {
            // console.log("chat", chat);
            // console.log("newUser", newUser);
            return chat.chat_session_id === newUser.chat_session_id;
          });

          // console.log("isChatSessionIdPresent", isChatSessionIdPresent);
          if (!isChatSessionIdPresent) {
            // console.log("new user");
            props.AddNewChat(newUser);
            playRingSound();
          } else {
            // console.log("user already present");
          }
        }
      } catch (error) {
        console.log("get-new-reqerror",error)
      }
    });
    socket.current.on("typing-msg-receive", (msg) => {
      // console.log("typing-msg-receive", msg);
      if (!msg) return;
      let loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
      if (msg.chatdetails.chat_type == "internal") {
        if (msg.chatType == "inbound") {
          if (loggedInAgent.agent_id == msg.to) {
            props.setCustomerTyping(true);
            props.setCustomerTypingId(msg.from);
          }
        } else {
          if (loggedInAgent.agent_id == msg.chatdetails.reciverDetails[0]._id) {
            props.setCustomerTyping(true);
            props.setCustomerTypingId(msg.from);
          }
        }
      } else {
        if (loggedInAgent.agent_id == msg.to) {
          props.setCustomerTyping(true);
          props.setCustomerTypingId(msg.from);
        }
      }
    });
    socket.current.on("msg-receive", (msg) => {
      // console.log("msg-receive", msg);
      if (!msg) return;
      try {
        if ((selectedChat ? selectedChat.chat_type : "") === "internal") {
          if (msg.chatType === "inbound") {
            if ((selectedChat ? selectedChat.agent : "") === msg.to) {
              // console.log("msg-receive - inbound", msg);
              // console.log("msg-receive inbound selectedChat", selectedChat);
              props.setArrivalMessage({
                fromSelf: false,
                session_id: msg.session_id,
                message: msg.msg,
                senderName: msg.senderName,
                sender: msg.to,
                receiver: msg.from,
                time: moment().format("lll"),
                msg_sent_type: msg.msg_sent_type,
                file_name: msg.file_name,
                captions: msg.captions,
              });
              props.setCustomerTyping(false);
            }
          } else {
            if ((selectedChat ? selectedChat.agent : "") === msg.from) {
              // console.log("msg-receive - outbound", msg);
              // console.log("msg-receive outbound selectedChat", selectedChat);
              props.setArrivalMessage({
                fromSelf: false,
                session_id: msg.session_id,
                message: msg.msg,
                senderName: msg.senderName,
                sender: msg.to,
                receiver: msg.from,
                time: moment().format("lll"),
                msg_sent_type: msg.msg_sent_type,
                file_name: msg.file_name,
                captions: msg.captions,
              });
              props.setCustomerTyping(false);
            }
          }
          props.setCustomerTypingId("");
        } else {
          const existingUser = JSON.parse(
            localStorage.getItem("contactList"),
          ).find((user) => {
            return user.chat_session_id == msg.session_id;
          });
          // console.log("existingUser", existingUser);

          if (existingUser) {
            // console.log("msg-receive - external", msg);
            // console.log("selectedChat - external", selectedChat);
            if ((selectedChat ? selectedChat.id : "") == msg.from) {
              props.setArrivalMessage({
                fromSelf: false,
                message: msg.msg,
                session_id: msg.session_id,
                senderName: msg.senderName,
                sender: msg.from,
                receiver: msg.to,
                time: moment().format("lll"),
                msg_sent_type: msg.msg_sent_type,
                file_name: msg.file_name,
                captions: msg.captions,
              });
            }

            if (
              msg.conference &&
              (selectedChat ? selectedChat.id : "") == msg.to &&
              msg.from !== datas.agent_id
            ) {
              props.setArrivalMessage({
                fromSelf: true,
                message: msg.msg,
                session_id: msg.session_id,
                senderName: msg.senderName,
                sender: msg.from,
                receiver: msg.to,
                msg_sent_type: msg.msg_sent_type,
                file_name: msg.file_name,
                captions: msg.captions,
                time: moment().format("lll"),
              });
              props.setCustomerTyping(false);
            }
            props.setCustomerTyping(false);
            props.setCustomerTypingId("");
          } else {
            return;
          }
        }
      } catch (error) {
        // console.log("msg-receive", error);
      }
    });
    socket.current.on("last-msg-receive", (msg) => {
      if (msg.userType === "internal") {
        // console.log("last-msg-receive", msg);

        props.showLastMsgInternal(msg, playRingSound2, playMsgTone);
      } else {
        // console.log("last-msg-receive", msg);

        let contactlist = JSON.parse(localStorage.getItem("contactList")) || [];

        if (msg.chatType == "inbound") {
          const existingUser = contactlist.find((user) => user.id == msg.from);

          if (existingUser) {
            props.showLastMsgExternal(msg, playRingSound2, playMsgTone);
          } else {
            return;
          }
        } else {
          const existingUser = contactlist.find((user) => user.id == msg.to);

          if (existingUser) {
            props.showLastMsgExternal(msg, playRingSound2, playMsgTone);
          } else {
            return;
          }
        }
      }
    });
    socket.current.on("get-new-req-conf", (newUser) => {
      // console.log("conferance chat", newUser);
      let loogedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
      if (newUser[0].conference_agent == loogedInAgent.agent_id) {
        playRingSound();
        // console.log("newUser", newUser);
        var newNotification = {
          id: newUser[0].unique_id.id,
          username: newUser[0].unique_id.username,
          client_msg: newUser[0].lastmessage,
          from_id: newUser[0].agent,
          chatType: "Conferance Chat",
        };
        props.updateNotification(newNotification);
        props.GetAllUsers();
      }
    });
    socket.current.on("customer-end-chat", (data) => {
      // console.log("customer-end-chat", data);
      if (!data) return;
      let contactlist = JSON.parse(localStorage.getItem("contactList")) || [];
      const existingUser = contactlist.find((user) => {
        return user.chat_session_id == data.chat_session_id;
      });

      if (existingUser) {
        var newcontactlist = [];
        contactlist.map((client) => {
          if (client.chat_session_id == data.chat_session_id) {
            client.is_customer_disconnected = true;
          }
          newcontactlist.push(client);
        });
        props.updateContactList(newcontactlist);
        if (
          (selectedChat ? selectedChat.chat_session_id : "") ==
          data.chat_session_id
        ) {
          props.updateSetExternalChatData(props.externalChatData);
        }
      } else {
        return;
      }
    });
    socket.current.on("update-changestatus-supervisor", (newStatus) => {
      // console.log("update-changestatus-supervisor", newStatus);
      const agent = JSON.parse(localStorage.getItem("tokenAgent"));
      if (agent.user_id == newStatus.user_id) {
        if (localStorage.getItem("AgentStatus") == "Connected") {
          loginbyDomain();
        } else {
          updateStatus(newStatus.status);
        }
      }
    });
    socket.current.on("update-force-logout", (logoutAgent) => {
      try {
        const agent = JSON.parse(localStorage.getItem("tokenAgent"));
        if (agent.user_id == logoutAgent.user_id) {
          localStorage.removeItem("AvayaUsername");
          localStorage.removeItem("tab");
          localStorage.removeItem("timer_connect_sec");
          localStorage.removeItem("AvayaPassword");
          localStorage.removeItem("AvayaDomain");
          localStorage.removeItem("client");
          localStorage.removeItem("statusValue");
          localStorage.removeItem("emailDisplay");
          localStorage.removeItem("timer_connect_min");
          localStorage.removeItem("tokenAgent");
          localStorage.removeItem("timer_status");
          localStorage.removeItem("NameDisplay");
          localStorage.removeItem("access_token");
          localStorage.removeItem("timer_connect_hour");
          localStorage.removeItem("EnableWEBRTC");
          localStorage.removeItem("ticketcrm");
          localStorage.removeItem("agentLoginTerminalId");
          localStorage.removeItem("storeTopicValue");
          if (!localStorage.getItem("TenantId")) {
            window.location.href = "error.html";
          } else {
            const loginUrl = `${localStorage.getItem("frontendBaseURL")}?tenantID=${encodeURIComponent(
              localStorage.getItem("TenantId"),
            )}`;
            window.location.href = loginUrl;
          }
          navigate("/");
        }
      } catch (error) {
        // console.log("update-force-logout", error);
      }
    });
    socket.current.on("update-agent-status-recv", (data) => {
      let agentList = JSON.parse(localStorage.getItem("agentList")) || [];

      const UserExist = agentList.find((user) => {
        if (
          user.reciverDetails[0].user_id == data.user_id ||
          user.senderDetails[0].user_id == data.user_id
        ) {
          return true;
        } else {
          return false;
        }
      });
      if (UserExist) {
        const updatedAgentList = agentList.map((client) => {
          if (client.reciverDetails[0].user_id === data.user_id) {
            return {
              ...client,
              reciverDetails: [
                {
                  ...client.reciverDetails[0],
                  agent_status: data.status,
                },
              ],
            };
          } else if (client.senderDetails[0].user_id === data.user_id) {
            return {
              ...client,
              senderDetails: [
                {
                  ...client.senderDetails[0],
                  agent_status: data.status,
                },
              ],
            };
          }
          return client;
        });

        // Now, you can use the updatedAgentList as needed
        props.setAgentList(updatedAgentList);
        localStorage.setItem("agentList", JSON.stringify(updatedAgentList));
      } else {
        return;
      }
    });
    socket.current.on("recv-internal", (newUser) => {
      // let lastElement = newUser.pop();
      // var oldReqAgent = props.agentList;
      // oldReqAgent = oldReqAgent.filter((item) => {
      //   return item.user_id != lastElement.user_id;
      // });
      // var listrequest = [];
      // props.setAgentList(oldReqAgent);
      // if (lastElement) {
      //   if (datas.id == lastElement.reciverDetails[0]._id) {
      //     listrequest = lastElement;
      //     oldReqAgent.push(listrequest);
      //   }
      // }
    });
    socket.current.on("email-receive", (data) => {});
    return () => {
      socket.current.off("get-new-req");
      socket.current.off("typing-msg-receive");
      socket.current.off("msg-receive");
      socket.current.off("last-msg-receive");
      socket.current.off("get-new-req-conf");
      socket.current.off("update-changestatus-supervisor");
      socket.current.off("update-force-logout");
      socket.current.off("update-agent-status-recv");
      socket.current.off("customer-end-chat");
      socket.current.off("email-receive");
    };
  }, [props.chatSessionId]);

  const loginbyDomain = () => {
    if (props.voiceAvailable) {
      axios
        .post(
          AvcUrl +
            `/voice/cct/login?username=${localStorage.getItem(
              "AvayaUsername",
            )}&password=${localStorage.getItem(
              "AvayaPassword",
            )}&domain=${localStorage.getItem("AvayaDomain")}`,
          {},
          {
            headers: {
              tenantId: localStorage.getItem("TenantId"),
            },
          },
        )
        .then((res) => {
          if ((res.data.status = "OK")) {
            localStorage.setItem("ssoToken", res.data.data.ssoToken);
            localStorage.setItem(
              "agentLoginTerminalId",
              res.data.data.agents[0].agentLoginId,
            );
            localStorage.setItem(
              "agentUsername",
              res.data.data.agents[0].agentUsername,
            );
            loginbyDomainforAgent(
              res.data.data.agents[0].agentLoginId,
              res.data.data.ssoToken,
              res.data.data.agents[0].agentUsername,
            );
          } else {
            let data = JSON.parse(localStorage.getItem("tokenAgent"));
            axios
              .post(
                BaseUrl + "/users/updateAgentStatus/",
                {
                  status: "Ready",
                  userId: data.user_id,
                },
                {
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token"),
                    "Content-Type": "application/json",
                    tenantId: localStorage.getItem("TenantId"),
                  },
                },
              )
              .then((res) => {
                if (res.data.status) {
                  props.setShowingStatus("Ready");
                  localStorage.setItem("AgentStatus", "Ready");
                  props.setShowingStatusClass("showStatus");
                  props.setShowingStatusVoice("Not Connected");
                  props.setReadyButton(true);
                } else {
                  props.setShowingStatus("Connected");
                  localStorage.setItem("AgentStatus", "Connected");
                  props.setShowingStatusClass("showStatusConnected");
                  props.setShowingStatusVoice("Connected");
                  props.setReadyButton(false);
                }
              })
              .catch((err) => {
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
              });

            ErrorNotification("Voice LogIn", res.data.message);
          }
        })
        .catch((error) => {
          let data = JSON.parse(localStorage.getItem("tokenAgent"));
          axios
            .post(
              BaseUrl + "/users/updateAgentStatus/",
              {
                status: "Ready",
                userId: data.user_id,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              },
            )
            .then((res) => {
              if (res.data.status) {
                props.setShowingStatus("Ready");
                localStorage.setItem("AgentStatus", "Ready");
                props.setShowingStatusClass("showStatus");
                props.setShowingStatusVoice("Not Connected");
                props.setReadyButton(true);
              } else {
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
              }
            })
            .catch((err) => {
              props.setShowingStatus("Connected");
              localStorage.setItem("AgentStatus", "Connected");
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              props.setReadyButton(false);
            });

          ErrorNotification("Voice LogIn", res.data.message);
        });
    } else {
      updateStatus("Ready");
    }
  };
  const loginbyDomainforAgent = (terminalId, ssoToken, agentUsername) => {
    if (!terminalId && !ssoToken) return;
    axios
      .post(
        AvcUrl +
          `/voice/cct/agent/${terminalId}/login/${terminalId}?status=Ready`,
        {},
        {
          headers: {
            ssoToken: ssoToken,
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if ((res.data.status = "OK")) {
          localStorage.setItem("VoiceStatuslastApiCallTime", Date.now());
          let data = JSON.parse(localStorage.getItem("tokenAgent"));
          axios
            .post(
              BaseUrl + "/users/updateAgentStatus/",
              {
                status: "Ready",
                userId: data.user_id,
                agentLoginTerminalId: terminalId,
                agentUsername: agentUsername,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              },
            )
            .then((res) => {
              if (res.data.status) {
                props.setShowingStatus("Ready");
                localStorage.setItem("AgentStatus", "Ready");
                props.setShowingStatusClass("showStatus");
                props.setShowingStatusVoice("Ready");
                props.setReadyButton(true);
                setTimeout(() => {
                  window.location.reload(true);
                }, 2000);
              } else {
                props.setShowingStatus("Connected");
                localStorage.setItem("AgentStatus", "Connected");
                props.setShowingStatusClass("showStatusConnected");
                props.setShowingStatusVoice("Connected");
                props.setReadyButton(false);
                toast.warn("Please Try Again After Some Time", toaststyle);
              }
            })
            .catch((err) => {
              props.setShowingStatus("Connected");
              localStorage.setItem("AgentStatus", "Connected");
              props.setShowingStatusClass("showStatusConnected");
              props.setShowingStatusVoice("Connected");
              props.setReadyButton(false);
            });
        } else {
          updateStatus("Ready");
          props.setShowingStatusVoice("Not Connected");
          ErrorNotification("Voice LogIn", error.message);
        }
      })
      .catch((error) => {
        updateStatus("Ready");
        props.setShowingStatusVoice("Not Connected");
        ErrorNotification("Voice LogIn", error.message);
      });
  };
  const updateStatus = (value) => {
    if (!value) return;
    let data = JSON.parse(localStorage.getItem("tokenAgent"));
    axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: data.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {
        if (res.data.status) {
          if (value == "Connected") {
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatusConnected");
            props.setShowingStatusVoice("Connected");
            localStorage.removeItem("ssoToken");
            localStorage.removeItem("agentLoginTerminalId");
            localStorage.removeItem("agentUsername");
            localStorage.removeItem("statusValue");
            props.setReadyButton(false);
          } else if (value == "Ready") {
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatus");
            if (props.showingStatusVoice == "Not Connected") {
            } else {
              changeStatusVoice("Ready", "Ready");
            }
          } else {
            props.setReadyButton(true);
            props.setShowingStatus(value);
            localStorage.setItem("AgentStatus", value);
            props.setShowingStatusClass("showStatusRed");
            if (props.showingStatusVoice == "Not Connected") {
            } else {
              changeStatusVoice("Not Ready", "Not Ready");
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const updateStatusRinging = (value) => {
    if (!value) return;
    let data = JSON.parse(localStorage.getItem("tokenAgent"));
    axios
      .post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: value,
          userId: data.user_id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then((res) => {})
      .catch((err) => {
        console.log(err);
      });
  };
  const changeStatusVoice = (status, value2) => {
    if (props.voicePlatForm == "AES") return;
    if (props.voiceAvailable) {
      axios
        .post(
          AvcUrl +
            `/voice/cct/agent/${localStorage.getItem(
              "agentLoginTerminalId",
            )}/status?status=${status}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken")
                ? localStorage.getItem("ssoToken")
                : "",
              tenantId: localStorage.getItem("TenantId"),
            },
          },
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("VoiceStatuslastApiCallTime", Date.now());
            props.setShowingStatusVoice(value2);
            if (status == "Ready") {
              localStorage.removeItem("VoiceActivate");
            }
          } else {
            ErrorNotification("Voice Status", res.data.message);
            props.setShowingStatusVoice("Not Connected");
          }
        })
        .catch((error) => {
          ErrorNotification("Voice Status", error.message);
          props.setShowingStatusVoice("Not Connected");
        });
    }
  };
  const ErrorNotification = (headerMsg, msg) => {
    const randomChars = Math.random().toString(36).substring(2, 10);
    const timestamp = new Date().getTime().toString(36);
    const randomId = randomChars + timestamp;
    var newNotification = {
      id: randomId,
      username: headerMsg,
      client_msg: msg,
      from_id: "voice api",
      chatType: "Error Message",
    };
    props.updateNotification(newNotification);
  };
  // sdk functionality------------------------------------------------------
  const Display_Ringing_Screen = (responseData) => {
    props.CustomerNameApi(
      responseData.callingDeviceID != null
        ? responseData.callingDeviceID
        : responseData.callerId,
    );
    playIncomingCall();
    localStorage.setItem(
      "incomingNumber",
      responseData.callingDeviceID != null
        ? responseData.callingDeviceID
        : responseData.callerId,
    );
    localStorage.setItem(
      "callArrivalTime",
      moment2().tz("Asia/Dubai").format(),
    );
    localStorage.setItem("contactId", responseData.contactId);
    localStorage.setItem(
      "SkillSet",
      responseData.skillSet == null ? "NA" : responseData.skillSet,
    );
    props.setshowIncommingscreen(true);
    props.setshowphonedialer(false);
    props.setDialedNumberInc(
      responseData.callingDeviceID != null
        ? responseData.callingDeviceID
        : responseData.callerId,
    );
    updateStatusRinging("Ringing");
  };
  const Remove_Ringing_Screen = (responseData) => {
    if (localStorage.getItem("contactId") == responseData?.contactId) {
      pauseIncomingCall();
      props.setDialedNumberInc("");
      props.setshowIncommingscreen(false);
      props.setshowphonedialer(false);
      JSON.parse(localStorage.getItem("permission")).map(async (module) => {
        if (module.moduleName === "VOICE_INTERACTION") {
          const isAutoCallDrop = module.screen.find(
            (item) =>
              item.screenId === "READY_FOR_AUTO_CALL_DROP" &&
              item.read &&
              item.write,
          );
          if (isAutoCallDrop) {
            setSeconds(15);
            setAutoCallDropOpen(true);
          } else {
            updateStatus("Not Ready");
          }
        }
      });
      CreateAbandoned();
    }
  };
  const Display_Consulted_Ringing_Screen = (responseData) => {
    props.CustomerNameApi(
      responseData.callingDeviceID != null
        ? responseData.callingDeviceID
        : responseData.callerId,
    );
    playIncomingCall();

    localStorage.setItem(
      "incomingNumber",
      responseData.callingDeviceID != null
        ? responseData.callingDeviceID
        : responseData.callerId,
    );
    localStorage.setItem(
      "callArrivalTime",
      moment2().tz("Asia/Dubai").format(),
    );
    localStorage.setItem("contactId", responseData.contactId);
    localStorage.setItem("mainContactId", responseData.mainContactId);
    localStorage.setItem(
      "SkillSet",
      responseData.skillSet == null ? "NA" : responseData.skillSet,
    );
    props.setshowIncommingscreen(true);
    props.setshowphonedialer(false);
    props.setDialedNumberInc(
      responseData.callingDeviceID != null
        ? responseData.callingDeviceID
        : responseData.callerId,
    );
    updateStatusRinging("Ringing");
  };
  const Remove_Consulted_Ringing_Screen = () => {
    pauseIncomingCall();
    props.setDialedNumberInc("");
    props.setshowIncommingscreen(false);
    props.setshowphonedialer(false);
    updateStatus("ACW");
    CreateAbandoned();
  };
  const Display_Call_Screen = (responseData) => {
    const callList = JSON.parse(localStorage.getItem("callList")) || [];
    if (callList.length == 0) {
      stopwatch1.start();
      props.addCallToList(responseData);
      pauseIncomingCall();
      props.setshowphonedialer(false);
      props.setshowIncommingscreen(false);
      updateStatus("InCall");
      navigate("/main/Chat");
      props.setsidebarVal("Chat");
      localStorage.setItem("callCutByAgent", "false");
    } else {
      props.unHoldCall(responseData);
    }
  };
  const Display_Call_Screen_2 = (responseData) => {
    const callList = JSON.parse(localStorage.getItem("callList"));
    if (callList.length != 0 && responseData.reason === "CONSULT_INIT") {
      props.setconsultedContactId(responseData.contactId);
      localStorage.setItem("consultedContactId", responseData.contactId);
      props.add2CallToList(responseData);
      stopwatch2.start();
      localStorage.removeItem("consultedDialedNumber");
      return;
    } else if (callList.length == 0) {
      stopwatch1.start();
      props.addCallToList({ ...responseData, callType: "Inbound" });
      pauseIncomingCall();
      props.setshowphonedialer(false);
      props.setshowIncommingscreen(false);
      updateStatus("InCall");
      navigate("/main/Chat");
      props.setsidebarVal("Chat");
      localStorage.setItem("callCutByAgent", "false");
    } else {
      props.unHoldCall(responseData);
    }
  };
  const CheckAutoWrapUpForIntetnal = () => {
    JSON.parse(localStorage.getItem("permission")).map((module) => {
      if (module.moduleName === "VOICE_INTERACTION") {
        const value = module.screen.some(
          (item) =>
            item.screenId === "AUTO_WRAPUP_INTERNAL" &&
            item.read === true &&
            item.write === true,
        );
        if (value) {
          endChat(props.externalChatData);
          if (localStorage.getItem("VoiceCallStatus") == "Outbound") {
            updateStatus("Outbound");
          } else {
            updateStatus("Ready");
          }
          localStorage.removeItem("incomingNumber");
          localStorage.removeItem("dailedNumber");
        } else {
          props.setendchatModalDialog(true);
          if (localStorage.getItem("VoiceCallStatus") == "Outbound") {
            updateStatus("Outbound");
          } else {
            updateStatus("ACW");
          }
          localStorage.removeItem("incomingNumber");
          localStorage.removeItem("dailedNumber");
        }
      }
    });
    localStorage.removeItem("incomingNumber");
    localStorage.removeItem("Bargin");
    localStorage.removeItem("incomingNumber");
    localStorage.removeItem("dailedNumber");
  };
  const helperFunctionForVoice = (res) => {
    props.setendchatModalDialog(true);
    if (localStorage.getItem("VoiceCallStatus") == "Outbound") {
      updateStatus("Outbound");
    } else {
      updateStatus("ACW");
    }
    localStorage.removeItem("incomingNumber");
    localStorage.removeItem("Bargin");
    localStorage.removeItem("incomingNumber");
    localStorage.removeItem("dailedNumber");
  };
  const Remove_Call_Screen = (responseData) => {
    props
      .removeCallFromList(responseData)
      .then((res) => {
        if (res.status) {
          localStorage.removeItem("DCC_CALL");
          props.setshowIncommingscreen(false);
          if (localStorage.getItem("callCutByAgent") == "true") {
            DummyReport("callEnd", {
              contactId: res.responseData.contactId,
              endType: "agent",
            });
            localStorage.setItem("callCutByAgent", "false");
          } else {
            DummyReport("callEnd", {
              contactId: res.responseData.contactId,
              endType: "customer",
            });
            localStorage.setItem("callCutByAgent", "false");
          }
          const Contactlist = JSON.parse(
            localStorage.getItem("contactList"),
          ).find((list) => list.voice_contactId == responseData.contactId);
          if (Contactlist) {
            localStorage.setItem("client", JSON.stringify(Contactlist));
          }
          if (res.responseData.phone.length <= 5) {
            CheckAutoWrapUpForIntetnal(res);
          } else {
            helperFunctionForVoice(res);
          }
          stopwatch1.pause();
          stopwatch1.reset();
        }
      })
      .catch((err) => {});
  };
  const Remove_Transfered_Call_Screen = (responseData) => {
    props
      .callTransfered(responseData)
      .then((res) => {
        if (res.status) {
          localStorage.removeItem("DCC_CALL");
          const Contactlist = JSON.parse(
            localStorage.getItem("contactList"),
          ).find((list) => list.voice_contactId == res.responseData.contactId);
          if (Contactlist) {
            localStorage.setItem("client", JSON.stringify(Contactlist));
          }
          if (res.responseData.phone.length <= 5) {
            CheckAutoWrapUpForIntetnal(res);
          } else {
            helperFunctionForVoice(res);
          }
          stopwatch1.pause();
          stopwatch2.pause();
          stopwatch1.reset();
          stopwatch2.reset();
        }
      })
      .catch((err) => {});
  };
  // ACCS & AACC--------------------------------------------
  const initiateWebSocket = () => {
    if (stompClient.current && stompClient.current.connected) return;
    const connect = () => {
      const customHeaders = {
        terminal: localStorage.getItem("ssoToken"), //ssoToken
      };
      let newsocket = new SockJS(AvcUrl + "/ws");
      stompClient.current = Stomp.over(newsocket);

      stompClient.current.connect(
        customHeaders,
        () => {
          console.log("Connected to WebSocket");
          onConnected();
        },
        (error) => {
          console.error("WebSocket connection error:", error);
          toast.error("Voice Down", toaststyle);
          onError();
          setTimeout(connect, 5000); // Retry connection after 5 seconds
        },
      );
    };
    connect();
  };
  const handleReconnection = () => {
    // Clean up existing connection if necessary
    if (stompClient.current && stompClient.current.connected) {
      stompClient.current.disconnect(() => {
        console.log("WebSocket disconnected, attempting to reconnect...");
      });
    }
    loginbyDomain();
    // Try reconnecting
    initiateWebSocket();
  };
  const onConnected = () => {
    if (!stompClient.current) return;
    stompClient.current.subscribe("/user/terminal/messages", (payload) => {
      // console.log("Message received:", payload.body);
      const responseData = JSON.parse(payload.body);
      switch (responseData.event) {
        case "RINGING":
          console.log("RINGING", responseData);
          if (responseData.callType == "ConsultConference") {
            Display_Consulted_Ringing_Screen(responseData);
          } else {
            Display_Ringing_Screen(responseData);
          }
          break;
        case "ACTIVE":
          console.log("ACTIVE", responseData);
          switch (responseData.callType) {
            case "Inbound":
              if (responseData.reason == "TRANSFER_COMPLETE") {
                props.swapTransferCallToMainCall(responseData);
              } else if (responseData.reason == "CONFERENCE_COMPLETE") {
                props.callConferanced(responseData);
              } else {
                Display_Call_Screen(responseData);
              }
              break;
            case "Outbound":
              if (responseData.reason == "TRANSFER_COMPLETE") {
                props.swapTransferCallToMainCall(responseData);
              } else if (responseData.reason == "CONFERENCE_COMPLETE") {
                props.callConferanced(responseData);
              } else {
                if (
                  localStorage.getItem("agentLoginTerminalId") ==
                  responseData.callingDeviceID
                ) {
                  Display_Call_Screen({
                    ...responseData,
                    calledDeviceID:
                      localStorage.getItem("dailedNumber") ||
                      responseData.callingDeviceID,
                  });
                } else {
                  Display_Call_Screen({
                    ...responseData,
                    callType: "Inbound",
                  });
                }
              }
              break;
            case "ConsultConference":
              if (
                localStorage.getItem("agentLoginTerminalId") ==
                responseData.callingDeviceID
              ) {
                Display_Call_Screen_2({
                  ...responseData,
                  calledDeviceID: localStorage.getItem("consultedDialedNumber"),
                });
              } else {
                Display_Call_Screen_2({
                  ...responseData,
                  callType: "Inbound",
                });
              }
              break;
            default:
              break;
          }
          break;
        case "HELD":
          console.log("HELD", responseData);
          switch (responseData.callType) {
            case "Inbound":
              if (responseData.reason == "CONSULT_INIT") {
                props.ConsultedHoldCall(responseData);
              } else {
                props.holdCall(responseData);
              }
              break;
            case "Outbound":
              if (responseData.reason == "CONSULT_INIT") {
                props.ConsultedHoldCall(responseData);
              } else {
                props.holdCall(responseData);
              }
              break;
            case "ConsultConference":
              if (responseData.reason == "CONSULT_INIT") {
                props.ConsultedHoldCall(responseData);
              } else {
                props.holdCall(responseData);
              }
              break;
            default:
              break;
          }
          break;
        case "DROPPED":
          console.log("DROPPED", responseData);
          // if(localStorage.getItem("contactId")){
          switch (responseData.reason) {
            case "DEFAULT":
            case "OBSERVE":
              if (responseData.callType == "ConsultConference") {
                Remove_Consulted_Ringing_Screen();
              } else {
                const callList =
                  JSON.parse(localStorage.getItem("callList")) || [];
                if (callList.length != 0) {
                  Remove_Call_Screen(responseData);
                } else {
                  Remove_Ringing_Screen(responseData);
                }
              }
              break;
            case "TRANSFER_COMPLETE":
              Remove_Transfered_Call_Screen(responseData);
              break;
            case "CONFERENCE_COMPLETE":
              props.removeSecondCallFromConferance(responseData);
              break;
            default:
              Remove_Ringing_Screen(responseData);
              break;
            // }
          }
          break;
        case "FAILED":
          console.log("FAILED", responseData);
          end_call();
          break;
        default:
          break;
      }
    });
  };
  const onError = (error) => {
    console.error("WebSocket error:", error);
    toast.error("Voice Down", toaststyle);
    // handleReconnection();
  };
  // WEBRTC-------------------------------------------------
  const configuration = () => {
    var cli = new AWL.client();
    props.setCli(cli);

    if (cli) {
      console.log("cli", cli);
      cli.enableLogging();
      var appInstanceId = cli.generateAppInstanceID();
      console.log("The ApplicationInstanceID: " + appInstanceId);

      var cfg = {
        serviceType: "phone",
        enableVideo: false,
        Gateway: { ip: "ucd.inaipi.me", port: "5060" },
        Stunserver: { ip: "", port: "3478" },
        Turnserver: { ip: "", port: "3478", user: "", pwd: "" },
        AppData: {
          applicationID: "xxxx12345",
          applicationUA: "sdktestclient-3.0.0",
          appInstanceID: appInstanceId,
        },
        disableResiliency: false,
      };
      function onConfigChanged(resp) {
        console.log("onConfigChanged :: RESULT = " + resp.result);
        console.log("onConfigChanged :: reason = " + resp.reason);
      }
      function onRegistrationStateChanged(resp) {
        console.log("\n onRegistrationStateChange :: RESULT = " + resp.result);
        console.log("\n onRegistrationStateChange :: reason = " + resp.reason);
        switch (resp.result) {
          case "AWL_MSG_LOGIN_SUCCESS":
            toast.success("Connected", toaststyle);
            localStorage.setItem("webRTC_Status", "Connected");
            break;
          case "AWL_MSG_FAILING_OVER":
          case "AWL_MSG_FAILING_BACK":
            toast.error(resp.reason, toaststyle);
            break;
          case "AWL_MSG_FAIL_OVER_SUCCESS":
          case "AWL_MSG_FAIL_BACK_SUCCESS":
          case "AWL_MSG_RELOGGED_IN":
            toast.error("Disconnected", toaststyle);
            localStorage.setItem("webRTC_Status", "Disconnected");
            break;
          case "AWL_MSG_FAIL_OVER_FAILED":
          case "AWL_MSG_FAIL_BACK_FAILED":
          case "AWL_MSG_LOGIN_FAILED":
          case "AWL_MSG_LOGGEDOUT":
            toast.error("Disconnected", toaststyle);
            localStorage.setItem("webRTC_Status", "Disconnected");
            break;
          case "AWL_MSG_LOGIN_WEBSOCKET_FAILURE":
            toast.error("Voice Login Fail", toaststyle);
            localStorage.setItem("webRTC_Status", "Disconnected");
            break;
          default:
            break;
        }
      }
      var onCallListener = new CallListener();
      function onAuthTokenRenewed(resp) {
        if (resp.result == "AWL_MSG_TOKEN_RENEW_SUCCESS") {
          console.log("onAuthTokenRenewed:: Token is successfully renewed");
        } else {
          console.log(
            "onAuthTokenRenewed:: Token renewal failed. reason: " + resp.reason,
          );
        }
      }

      if (
        cli.setConfiguration(
          cfg,
          onConfigChanged,
          onRegistrationStateChanged,
          onCallListener,
          onAuthTokenRenewed,
        ) === "AWL_MSG_SETCONFIG_SUCCESS"
      ) {
        console.log("SETCONFIG SUCCESS");
      }
      var stunServer = { ip: "ucd.inaipi.me", port: "5060" };
      var stunresult = cli.setStunConfiguration(stunServer);

      if (stunresult === "AWL_MSG_SET_STUN_CONFIG_SUCCESS") {
        console.log("Successfully configured STUN settings");
      } else {
        console.log("Could not configure STUN settings. Re-check the values");
      }

      if (props.voicePlatForm == "ACR" || props.voicePlatForm == "AACC") {
        ExtNo.current = datas.voiceRecord.avayaUserName;
        ExtPass.current = datas.voiceRecord.avayaPassword;
      } else {
        ExtNo.current = localStorage.getItem("agentLoginTerminalId");
        ExtPass.current = "135970";
      }

      cli.logIn(ExtNo.current, ExtPass.current, "false");
    }
  };
  let CallListener = function () {
    var _onNewIncomingCall = function (callId, callObj, autoAnswer) {
      localStorage.setItem("callId", callObj.getCallId());
    };
    var _onCallStateChange = async (callId, callObj, currentCallState) => {
      console.log("_onCallStateChange", callId, "=", currentCallState);
      if (props.voicePlatForm == "ACR") {
        if (
          callId == callObj1.current.getCallId() &&
          callObj1.current != null
        ) {
          console.log("CallObj ====== 1: " + callObj1.current.getCallState());
          switch (callObj1.current.getCallState()) {
            case "AWL_MSG_CALL_RINGING":
              break;
            case "AWL_MSG_CALL_CONNECTED":
              break;
            case "AWL_MSG_CALL_HELD":
              break;
            case "AWL_MSG_CALL_DISCONNECTED":
              break;
            case "AWL_MSG_CALL_FAILED":
              break;
            case "AWL_MSG_CALL_INCOMING":
              break;
            case "AWL_MSG_CALL_FAREND_UPDATE":
              break;
            default:
          }
        } else if (
          callId == callObj2.current.getCallId() &&
          callObj2.current != null
        ) {
          console.log("CallObj ====== 2: " + callObj2.current.getCallState());
          switch (callObj2.current.getCallState()) {
            case "AWL_MSG_CALL_RINGING":
              break;
            case "AWL_MSG_CALL_CONNECTED":
              break;
            case "AWL_MSG_CALL_DISCONNECTED":
              break;
            case "AWL_MSG_CALL_FAILED":
              break;
            case "AWL_MSG_CALL_INCOMING":
              break;
            case "AWL_MSG_CALL_HELD":
              break;
            case "AWL_MSG_CALL_FAREND_UPDATE":
              break;
            default:
          }
        }
      }
    };
    var _onCallTerminate = async (callId, CallEndReason) => {
      console.log("_onCallTerminate", callId, CallEndReason);
      if (props.voicePlatForm == "ACR") {
        if (
          callObj1.current != null &&
          callObj1.current.getCallId() === callId
        ) {
        } else if (
          callObj2.current != null &&
          callObj2.current.getCallId() === callId
        ) {
        } else {
          console.log("Call Id doesn't match ");
        }
      }
    };
    return {
      onNewIncomingCall: _onNewIncomingCall,
      onCallStateChange: _onCallStateChange,
      onCallTerminate: _onCallTerminate,
    };
  };
  // AES_LITE--------------------------------------------------------
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isAesLoginReload) {
        event.preventDefault();
        event.returnValue = "";
        LogoutAesLiteAgent();
        setIsAesLoginReload(false);
        UnRegisterExten();
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.addEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  const AesWebSocketConnect = () => {
    try {
      if (aesWebSocket.current) {
        aesWebSocket.current.close();
      }
      aesWebSocket.current = new WebSocket(wsUri, ["client", AesToken]);
      setAesSocket(aesWebSocket.current);
      aesWebSocket.current.onopen = (event) => {
        console.log("AES-SOCKET-CONNECTED:", event);
        toast.success("AES Socket Connected", toaststyle);
      };

      aesWebSocket.current.onmessage = (event) => {
        const parsedGet = JSON.parse(event.data);
        console.log("onmessage....", parsedGet);
        switch (parsedGet.Event) {
          case "Register":
            if (parsedGet.Status === "RegisteredOK") {
              toast.success("Register Successfully", toaststyle);
              setisAesReadyReload(true);
            }
            break;
          case "UnRegister":
            if (parsedGet.Status === "UnRegisterOK") {
              toast.success("UnRegister Successfully", toaststyle);
              setisAesReadyReload(false);
            }
            break;
          case "alerting":
            localStorage.setItem("callType", "Inbound");
            const getCallFrom = parsedGet.CallFrom;
            const removeColon = getCallFrom.split(":");
            const callFrom = removeColon[0];
            const createCallObj = {
              callingDeviceID: callFrom,
              callerId: callFrom,
              skillSet: null,
              contactId: parsedGet.CallerId,
            };

            Display_Ringing_Screen(createCallObj);
            localStorage.setItem(
              "CallerId",
              JSON.stringify(parsedGet.CallerId),
            );
            localStorage.setItem("callResponseData", JSON.stringify(parsedGet));
            break;
          case "initiated":
            localStorage.setItem("callType", "Outbound");
            const getCalledNumber = parsedGet.CalledNumber;
            const CallNumRemoveColon = getCalledNumber.split(":");
            const calledNumber = CallNumRemoveColon[0];
            const outboundCreateCall = {
              callType: localStorage.getItem("callType"),
              callerId: calledNumber,
              contactId: parsedGet.CallerId,
              callingDeviceID: calledNumber,
              skillset: null,
              externalContactId: parsedGet.CallerId,
              calledDeviceID: calledNumber,
              UUID_callingDeviceID: parsedGet.CallerId,
              callingAgentName: JSON.parse(
                localStorage.getItem("AvayaUsername"),
              ),
            };
            localStorage.setItem(
              "CallerId",
              JSON.stringify(parsedGet.CallerId),
            );
            localStorage.setItem(
              "callResponseData",
              JSON.stringify(outboundCreateCall),
            );
            Display_Call_Screen(outboundCreateCall);
            break;
          case "Answered":
            localStorage.setItem(
              "CallerId",
              JSON.stringify(parsedGet.InComeCallid),
            );
            const getResponseData = JSON.parse(
              localStorage.getItem("callResponseData"),
            );
            const getCallFrom1 = getResponseData.CallFrom;
            const removeColon1 = getCallFrom1.split(":");
            const CallFromNum = removeColon1[0];
            const CreateCallObj = {
              callType: localStorage.getItem("callType"),
              callerId: CallFromNum,
              contactId: getResponseData.CallerId,
              callingDeviceID: CallFromNum,
              skillset: null,
              externalContactId: getResponseData.CallerId,
              calledDeviceID: getResponseData.CallerId,
              UUID_callingDeviceID: getResponseData.CallerId,
              callingAgentName: JSON.parse(
                localStorage.getItem("AvayaUsername"),
              ),
            };
            localStorage.setItem(
              "CallerId",
              JSON.stringify(parsedGet.InComeCallid),
            );
            localStorage.setItem(
              "callResponseData",
              JSON.stringify(CreateCallObj),
            );
            Display_Call_Screen(CreateCallObj);
          case "Transfer":
            const TransferResponse = JSON.parse(
              localStorage.getItem("callResponseData"),
            );
            Remove_Call_Screen(TransferResponse);
            break;
          case "Conference":
            const consferResponse = JSON.parse(
              localStorage.getItem("callResponseData"),
            );
            props.changeIsConfer(consferResponse);
            break;
          case "SOActivate":
            if (parsedGet.ObserveeLocationVDN === "listen only mode") {
              const observeAgentListData = JSON.parse(
                localStorage.getItem("observeAgentList"),
              );
              const observeCallRes = {
                callType: "Observe",
                callerId: observeAgentListData.unique_id.phonenumber,
                contactId: observeAgentListData.unique_id.id,
                callingDeviceID: observeAgentListData.unique_id.phonenumber,
                skillset: null,
                externalContactId: observeAgentListData.unique_id.id,
                calledDeviceID: observeAgentListData.unique_id.username,
                UUID_callingDeviceID: observeAgentListData.unique_id.id,
                callingAgentName: JSON.parse(
                  localStorage.getItem("AvayaUsername"),
                ),
              };
              localStorage.setItem(
                "observeAgentList",
                JSON.stringify(observeCallRes),
              );
              Display_Call_Screen(observeCallRes);
              props.setIsBarginCall(true);
            } else if (parsedGet.ObserveeLocationVDN === "talk listen mode") {
              const observeAgentListData = JSON.parse(
                localStorage.getItem("observeAgentList"),
              );
              props.convertBarginCallToMainCall(observeAgentListData);
            }
          case "Hold":
            const responseData2 = JSON.parse(
              localStorage.getItem("callResponseData"),
            );
            props.holdCall(responseData2);
            break;
          case "RetrieveCall":
            const responseData3 = JSON.parse(
              localStorage.getItem("callResponseData"),
            );
            props.unHoldCall(responseData3);
            break;
          case "SODeActivate":
            const observeAgentListData2 = JSON.parse(
              localStorage.getItem("observeAgentList"),
            );
            Remove_Call_Screen(observeAgentListData2);
            localStorage.removeItem("observeAgentList");
            break;
          case "DisconnectCall":
            const getResponseData2 = JSON.parse(
              localStorage.getItem("callResponseData"),
            );
            const callList = JSON.parse(localStorage.getItem("callList")) || [];

            if (
              localStorage.getItem("callType") == "Outbound" ||
              localStorage.getItem("callType") == "Inbound"
            ) {
              if (callList.length != 0) {
                Remove_Call_Screen(getResponseData2);
              } else {
                Remove_Ringing_Screen();
              }
              localStorage.removeItem("callResponseData");
              localStorage.removeItem("conferResponseData");
              localStorage.removeItem("callType");
              localStorage.removeItem("CallerId");
            }
            break;
          default:
            break;
        }
      };

      aesWebSocket.current.onclose = (event) => {
        console.log("AES-SOCKET-DISCONNECTED:", event);
        toast.error("AES Socket Disonnected", toaststyle);
      };

      aesWebSocket.current.onerror = (event) => {
        console.log("onerror in AES lite:", event);
      };
    } catch (error) {
      console.log("AES-SOCKET", error);
    }
  };
  const RegisterExten = () => {
    const tokenAgent = JSON.parse(localStorage.getItem("tokenAgent"));
    const RegDetails = {
      Event: "Register",
      Extension: tokenAgent.voiceRecord.avayaUserName,
      Password: tokenAgent.voiceRecord.avayaPassword,
    };
    aesWebSocket.current.send(JSON.stringify(RegDetails));
  };
  const LoginAesLiteAgent = async () => {
    const agent = JSON.parse(localStorage.getItem("tokenAgent"));
    if (agent.role == "Agent") {
      const AgentloginStatus = {
        Event: "AgentState",
        Extension: JSON.parse(localStorage.getItem("AvayaUsername")),
        Agentname: agent.voiceRecord.avayaLoginId
          ? agent.voiceRecord.avayaLoginId
          : null,
        AgentPassword: JSON.parse(localStorage.getItem("AvayaPassword")),
        AgentReason: "Log In",
        AgentWorkmode: "Manual In",
        AcdGroup: "681",
      };
      aesWebSocket.current.send(JSON.stringify(AgentloginStatus));
      await axios.post(
        BaseUrl + "/users/updateAgentStatus/",
        {
          status: "Ready",
          userId: agent.user_id,
          agentUsername: JSON.parse(localStorage.getItem("AvayaUsername")),
          agentLoginTerminalId: agent.voiceRecord.avayaLoginId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      );
    }
  };
  const UnRegisterExten = () => {
    const UnregisterReg = {
      Event: "UnSubScribe",
      Extension: JSON.parse(localStorage.getItem("AvayaUsername")),
    };
    aesWebSocket.current.send(JSON.stringify(UnregisterReg));
  };
  const LogoutAesLiteAgent = () => {
    const agentLoginId = JSON.parse(localStorage.getItem("tokenAgent"));
    if (agentLoginId.role == "Agent") {
      const AgentLogoutStatus = {
        Event: "AgentState",
        Extension: JSON.parse(localStorage.getItem("AvayaUsername")),
        Agentname: agentLoginId.voiceRecord.avayaLoginId
          ? agentLoginId.voiceRecord.avayaLoginId
          : null,
        AgentPassword: JSON.parse(localStorage.getItem("AvayaPassword")),
        AgentReason: "Log Out",
        AgentWorkmode: "Manual In",
        AcdGroup: "681",
      };
      aesWebSocket.current.send(JSON.stringify(AgentLogoutStatus));
    }
  };
  // AES_LITE--------------------------------------------------------
  useEffect(() => {
    switch (props.voicePlatForm) {
      case "AACC":
      case "ACCS":
        if (
          (!props.webRTC && props.showingStatusVoice == "Ready") ||
          props.showingStatusVoice == "Not Ready"
        ) {
          initiateWebSocket();
          console.log("websocket");
        } else if (
          (props.webRTC && props.showingStatusVoice == "Ready") ||
          props.showingStatusVoice == "Not Ready"
        ) {
          console.log("webrtc and websocket");
          initiateWebSocket();
          configuration();
        }
        break;
      case "ACR":
        if (props.showingStatusVoice == "Ready") {
          if (localStorage.getItem("webRTC_Status") != "Connected") {
            configuration();
          }
        }
        break;
      case "AES":
        if (props.showingStatusVoice == "Ready") {
          AesWebSocketConnect();
          setTimeout(() => {
            RegisterExten();
            setIsAesLoginReload(true);
            setTimeout(() => {
              LoginAesLiteAgent();
            }, 1000);
          }, 1000);
        }
        break;
      default:
        break;
    }
  }, []);
  const endChat = () => {
    axios
      .post(
        BaseUrl + "/message/endchat",
        {
          chat_session_id: JSON.parse(localStorage.getItem("client"))
            .chat_session_id,
          chatendby: "Agent",
          reason: "Released",
          comment: "Completed",
          agent_id: JSON.parse(localStorage.getItem("tokenAgent")).id,
        },
        {
          headers: {
            tenantId: localStorage.getItem("TenantId"),
          },
        },
      )
      .then(async (res) => {
        if (res.data.success) {
          if (localStorage.getItem("VoiceCallStatus") == "Outbound") {
            updateStatus("Outbound");
          } else {
            updateStatus("Ready");
          }
          props.setExternalChatData("");
          props.UpdateExternalContactList(
            JSON.parse(localStorage.getItem("client")).chat_session_id,
          );
          localStorage.removeItem("client");
          toast.success("Interaction Ended Successfully", toaststyle);
        } else {
          toast.error("Something went wrong", toaststyle);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <audio ref={msgtone} src={msgToneSound} /> {/* active chat ring tune */}
      <audio ref={audioRef} src={audiosound} /> {/* new webchat call tune */}
      <audio ref={audioRef2} src={audiosound2} /> {/* new message call tune */}
      <audio ref={incomingCall} src={soundfile} />
      {/* new incoming call tune */}
      {props.showIncommingscreen && (
        <NewIncominCall referance={myref} aesSocket={aesSocket} />
      )}
      {OnlineStatus && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={true}
          message="No Internet. Reconnect To Keep The Conversation Going"
          key={"top" + "center"}
        >
          <Alert severity="error">
            No internet connection. Please reconnect to continue the
            conversation.
          </Alert>
        </Snackbar>
      )}
      <Box sx={{ height: "100%", width: "100%", background: "#f7f8fa" }}>
        <ToastContainer transition={Flip} limit={3} />
        <NewIncomingRequest />

        {showComposeMail && (
          <ComposeNewEmailComponent
            showComposeMail={showComposeMail}
            setshowComposeMail={setshowComposeMail}
          />
        )}

        <Stack sx={{ height: "100%", width: "100%" }}>
          <Box
            sx={{
              height: "48px",
              width: "100%",
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Navbar
              showComposeMail={showComposeMail}
              setshowComposeMail={setshowComposeMail}
              setDialedNumber={setDialedNumber}
              aesSocket={aesSocket}
              isAesReadyReload={isAesReadyReload}
              setIsAesLoginReload={setIsAesLoginReload}
            />
          </Box>

          <Box
            sx={{
              height: "calc(100% - 50px)",
              width: "100%",
              padding: "3px",
              gap: "1px",
            }}
          >
            <Stack
              direction={"row"}
              sx={{ width: "100%", height: "100%" }}
              justifyContent={"space-between"}
            >
              <Box
                sx={{
                  height: "100%",
                  width: "50px",
                  padding: "4px 0",
                }}
              >
                <Sidebar />
              </Box>

              <Box
                sx={{
                  height: "100%",
                  width: "calc(100% - 50px)",
                  overflow: "hidden",
                  padding: "7px",
                }}
              >
                <Paper
                  className="p-0"
                  elevation={0}
                  ref={myref}
                  sx={{
                    height: "100%",
                    background:
                      props.sidebarVal === "Chat" ? "#FFFFF" : "#FFFFF",
                    padding:
                      props.sidebarVal === "Chat" ? "5px 0px" : "5px 5px",
                    borderRadius: "7px",
                    overflowY: "auto",
                    boxShadow:
                      props.sidebarVal === "Chat"
                        ? "none"
                        : "rgb(50 50 93 / 18%) 0px 2px 5px -1px, rgb(0 0 0 / 32%) 0px 1px 3px -1px",
                  }}
                >
                  <Outlet
                    context={[
                      callObj2.current,
                      callmap.current,
                      playMsgTone,
                      stopwatch1,
                      stopwatch2,
                      aesSocket,
                    ]}
                  />
                </Paper>
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Box>
      {JSON.parse(localStorage.getItem("permission")).map((module, index) => {
        if (module.moduleName === "VOICE_INTERACTION") {
          const value = module.screen.find(
            (item) =>
              item.screenId === "AUTO_WRAPUP" &&
              item.read === true &&
              item.write === true,
          );

          if (value) {
            return (
              <>
                {props.endchatModalDialog && (
                  <EndChatModelForPopCall
                    key={index}
                    OpenDialog={props.endchatModalDialog}
                    handleClose={() => props.setendchatModalDialog(false)}
                  />
                )}
              </>
            );
          } else {
            return (
              <>
                {props.endchatModalDialog && (
                  <EndChatModel
                    key={index}
                    OpenDialog={props.endchatModalDialog}
                    handleClose={() => props.setendchatModalDialog(false)}
                  />
                )}
              </>
            );
          }
        }
      })}
      {props.voiceAvailable &&
        props.showphonedialer &&
        props.callList.length === 0 && (
          <Dialer
            dailedNumber={dailedNumber}
            setDialedNumber={setDialedNumber}
            referance={myref}
            callObj1={callObj1.current}
            callmap={callmap.current}
            aesSocket={aesSocket}
          />
        )}
      <React.Fragment>
        <Button variant="outlined" onClick={handleClickOpen}>
          Slide in alert dialog
        </Button>
        <Dialog
          open={autoCallDropOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              handleClose();
            }
          }}
          aria-describedby="alert-dialog-slide-description"
          PaperProps={{
            sx: {
              borderRadius: 3,
              boxShadow: 6,
              minWidth: 400,
              p: 1,
              backgroundColor: "#f9f9f9",
            },
          }}
        >
          <DialogTitle>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography variant="h6" fontWeight={600}>
                Missed Call Alert
              </Typography>
              <Typography
                sx={{ fontWeight: "600", textTransform: "capitalize" }}
              >
                {seconds >= 10 ? seconds : "0" + seconds} sec
              </Typography>
            </Stack>
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              You have missed a call.
              <br />
              Would you like to change your status to{" "}
              <span style={{ color: "#000000" }}>Not Ready</span> or{" "}
              <span style={{ color: "#000000" }}>Ready</span>?
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Stack
              direction="row"
              spacing={2}
              width="100%"
              justifyContent="flex-end"
            >
              <Button
                color="error"
                size="small"
                sx={{ fontWeight: 600 }}
                onClick={() => {
                  updateStatus("Not Ready");
                  handleClose();
                }}
              >
                Not Ready
              </Button>
              <Button
                color="success"
                size="small"
                sx={{ fontWeight: 600 }}
                onClick={() => {
                  updateStatus("Ready");
                  handleClose();
                }}
              >
                Go Ready
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  );
};
export default connect(mapStateToProps, {
  setMsgTone,
  setMsgTone2,
  setShowingStatus,
  setShowingStatusVoice,
  setShowingStatusClass,
  setReadyButton,
  updateNotification,
  setsidebarVal,
  setAgentList,
  endInteraction,
  setArrivalMessage,
  GetAllUsers,
  setValue,
  setExternalChatData,
  setcontactlist,
  updateContactList,
  getIncomingChatData,
  AddNewChat,
  setCustomerTyping,
  showLastMsgExternal,
  showLastMsgInternal,
  updateSetExternalChatData,
  setCustomerTypingId,
  UpdateExternalContactList,
  // sdk--------------------
  setDialedNumberInc,
  setshowIncommingscreen,
  setagentDialedNumber,
  setshowphonedialer,
  setconsultedContactId,
  setVoiceSessionId,
  setseletedVoiceSessionId,
  setCli,
  setendchatModalDialog,
  CustomerNameApi,
  addCallToList,
  add2CallToList,
  removeCallFromList,
  callTransfered,
  swapTransferCallToMainCall,
  removeSecondCallFromConferance,
  callConferanced,
  holdCall,
  ConsultedHoldCall,
  unHoldCall,
  changeIsConfer,
  convertBarginCallToMainCall,
  setIsBarginCall,
  // sdk--------------------
})(Main);
